export default __webpack_public_path__ + "static/media/suitcase.b2818837.svg";